
// export const logout = ( state ) => {
// }

export const setLots = (state, lots) => {
    state.lots = lots
}

export const setLotsSelectable = (state, lots) => {
    state.lotsSelectable = lots
}

export const setLotsPaginated = (state, lotsPaginatedData) => {
    state.lotsPaginatedData = lotsPaginatedData
}

export const setLotDetail = (state, lot) => {
    state.lot = lot
}

export const saveNewLot = (state, lot) => {
    state.lots.unshift(lot)
    state.createdData = lot;
}

export const saveUpdatedLot = (state, lot) => {
    state.lots.unshift(lot)
    state.updatedData = lot;
}

export const setDeleteLot = (state, lot) => {
    state.deletedData = lot
}

export const setLotIsLoading = (state, isLoading) => {
    state.isLoading = isLoading
}

export const setLotIsCreating = (state, isCreating) => {
    state.isCreating = isCreating
}

export const setLotIsUpdating = (state, isUpdating) => {
    state.isUpdating = isUpdating
}

export const setLotIsDeleting = (state, isDeleting) => {
    state.isDeleting = isDeleting
}

export const setLotIsFinding = (state, isFinding) => {
    state.isFinding = isFinding
}

export const isLotByNameExist = (state, existingLot) => {
    state.existingLot = existingLot
}
